<!--in stock-->
@if (product) {
  <div class="d-flex">
    @if (product.inventoryType) {
      <ng-container
        *ngTemplateOutlet="
          viewType === 'grid-item'
            ? gridView
            : viewType === 'sku-item'
              ? skuView
              : detailedView
        "
      ></ng-container>
    } @else {
      @if (discontinued) {
        <div class="info-item">
          <span>Availability: Discontinued</span>
        </div>
      }
      @if (!discontinued && !product.isBuyingWindow) {
        <div class="product--quantity" [ngClass]="className">
          <div class="info-item items-in-stock">
            <!--      <strong class="quantity sku-quantity empty"-->
            <!--        *ngIf="viewType === 'sku-item'"></strong>-->
            <span>{{ shippingTiming ? shippingTiming : 'Ready to Ship' }}</span>
          </div>
        </div>
      }
    }
  </div>
}

<ng-template #gridView>
  <div class="product--quantity text-align-start" [ngClass]="className">
    @if (isOutOfStock || inStockQuantity > 0) {
      <div class="info-item items-in-stock">
        @if (isOutOfStock) {
          <span class="out-of-stock color-red fw-bold">Out Of Stock</span>
        }
        @if (inStock && inStockQuantity > 0) {
          <strong class="quantity">{{ inStockQuantity }}</strong>
          <span>&nbsp;In Stock</span>
        }
      </div>
    }
    @if (hasPendingQuantity) {
      <div class="info-item items-on-order">
        <strong class="quantity">{{ pendingQuantity }}</strong>
        <span>&nbsp;On Order</span>
      </div>
    }
    @if (inStockQuantity > 0 && shippingTiming) {
      <div class="info-item">
        <span>{{ shippingTiming }}</span>
      </div>
    }
  </div>
</ng-template>

<ng-template #skuView>
  <div
    class="product--quantity full-width d-flex align-items-start"
    [ngClass]="className"
  >
    @if (inStockQuantity === 0 && pendingQuantity === 0) {
      <div class="info-item items-in-stock full-width">
        @if (orientation === 'vertical') {
          <strong class="quantity sku-quantity empty"></strong>
        }
        <span class="out-of-stock color-red fw-bold">Out Of Stock</span>
      </div>
    }
    @if (inStockQuantity > 0 || pendingQuantity > 0) {
      @if (orientation === 'vertical') {
        <div class="info-item items-in-stock">
          <strong class="quantity sku-quantity">{{ inStockQuantity }}</strong>
          <span>Items in Stock</span>
        </div>
      }
      @if (orientation === 'horizontal') {
        <div class="info-item items-in-stock">
          <span>In Stock: </span>
          <span>{{ inStockQuantity }}</span>
        </div>
      }
      @if (pendingQuantity) {
        @if (orientation === 'vertical') {
          <div class="info-item items-on-order">
            <strong class="quantity sku-quantity">{{ pendingQuantity }}</strong>
            <span>Items on Order</span>
          </div>
        }
        @if (orientation === 'horizontal') {
          <div class="info-item items-on-order">
            <span>On Order: </span>
            <span>{{ pendingQuantity }}</span>
          </div>
        }
      }
    }
  </div>
</ng-template>

<ng-template #detailedView>
  <div class="product--quantity" [ngClass]="className">
    @if (discontinued) {
      <div class="info-item">
        <span>Availability: Discontinued</span>
      </div>
    }
    @if (!discontinued && inStockQuantity === 0 && pendingQuantity === 0) {
      <div class="info-item items-in-stock">
        <span class="out-of-stock color-red fw-bold">Out Of Stock</span>
      </div>
    }
    @if (!discontinued && (inStockQuantity > 0 || pendingQuantity > 0)) {
      <div class="info-item items-in-stock">
        <span>Availability: </span>
        <span class="quantity">{{ inStockQuantity }}</span>
        <span>&nbsp;in Stock</span>
        @if (inStockQuantity > 0 && shippingTiming) {
          <span>&nbsp;|&nbsp;{{ shippingTiming }}</span>
        }
      </div>
      @if (pendingQuantity) {
        <div class="info-item items-on-order">
          <span>On Order: </span>
          <span class="quantity">{{ pendingQuantity }}</span>
          @if (inStockDate) {
            <span
              >&nbsp;|&nbsp;Due:&nbsp;{{
                inStockDate | dateFormat: 'MMM D, YYYY formatAsLocal'
              }}</span
            >
          }
        </div>
      }
      @if (isLimitedAvailability) {
        <div class="info-item">
          <span>Limited Availability</span>
        </div>
      }
    }
  </div>
</ng-template>
